import { isOnePageSite } from "./cta-defaults";

/**
 * Whether the site is one page, read from a section's Puck metadata (see isOnePageSite).
 * @param {unknown} metadata The section's Puck metadata.
 * @returns {boolean} True for a one-page site.
 */
const metadataIsOnePage = (metadata: unknown): boolean => {
  if (typeof metadata !== "object" || metadata === null) {
    return isOnePageSite();
  }
  const onePage = "onePage" in metadata && typeof metadata.onePage === "boolean" ? metadata.onePage : undefined,
    pagePaths = "pagePaths" in metadata && Array.isArray(metadata.pagePaths)
      ? metadata.pagePaths.filter((path): path is string => typeof path === "string")
      : undefined;
  return isOnePageSite(pagePaths, onePage);
};

export { metadataIsOnePage };
